import React from 'react'
import {withStyles} from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {DialogContent} from "@material-ui/core";

const styles = theme => ({
	dialogWrapper: {
		minHeight: 'calc(100vh - 300px)',
		boxSizing: 'border-box',
		padding: 20,
		position: 'relative'
	},
	dialogTitle: {
		'& > *': {
			fontSize: '175%',
			fontWeight: 800
		}
	},
	dialogContent: {
		backgroundColor: 'rgba(244, 236, 225, 0.2)',
		borderRadius: 2,
		margin: '0 24px',
		padding: 20,

		'& > *:last-child': {
			marginBottom: '0 !important'
		}
	},
	stepDescriptionWrapper: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: 10,
		fontSize: '180%',
		lineHeight: '150%',

		'& > dt': {
			marginRight: 30,
			width: 150,
			color: 'rgba(0,0,0,.65)'
		},
		'& > dd': {
			fontWeight: 800
		},


	},
	stepLabelWrapper: {
		display: 'flex',
		flexDirection: 'column',
		width: 180
	},
	stepperLabelStatus: {
		fontWeight: 700,
		fontSize: '185%'
	},
	stepperLabelTime: {
		color: 'rgba(0,0,0,0.65)',
		fontSize: '110%'
	},
	closeButton: {
		position: 'absolute',
		top: 10,
		right: 10
	}
});

export const StepDialog = (props) => {


	const steps = [
		'配送中',
		'到着',
		'荷卸',
		'納品完了'
	]

	const handleClose = () => {
		props.onClose(false)
	}

	const activeStep = () => {
		let _activeStep = -1
		props.status.forEach((status, index) => {
			if (status) _activeStep = index
		})
		return _activeStep
	}

	return (
		<Dialog onClose={handleClose} open={props.open} maxWidth={"md"}>
			<div className={props.classes.dialogWrapper}>
				<DialogTitle id="simple-dialog-title" className={props.classes.dialogTitle}>配送状況</DialogTitle>
				<DialogContent className={props.classes.dialogContent}>
					<dl className={props.classes.stepDescriptionWrapper}>
						<dt>荷主</dt>
						<dd>{props.NinushiName}</dd>
					</dl>
					<dl className={props.classes.stepDescriptionWrapper}>
						<dt>伝票番号</dt>
						<dd>{props.DenpyoNO}</dd>
					</dl>
					<dl className={props.classes.stepDescriptionWrapper}>
						<dt>納品予定日</dt>
						<dd>{props.NohinYoteiYMD}</dd>
					</dl>
				</DialogContent>
				<Stepper alternativeLabel nonLinear activeStep={activeStep}>
					{steps.map((label, index) => {
							const completed = !!props.status[index];
							const DisplayLabel = () => {
								if (completed) {
									return (
										<div className={props.classes.stepLabelWrapper}>
											<span className={props.classes.stepperLabelStatus}>{label}</span>
											<span className={props.classes.stepperLabelTime}>{props.status[index]}</span>
										</div>
									)
								} else {
									return (
										<div className={props.classes.stepLabelWrapper}>
											<span className={props.classes.stepperLabelStatus}>{label}</span>
										</div>
									)
								}
							}


							return (
								<Step key={label} completed={completed}>
									<StepLabel>
										<DisplayLabel/>
									</StepLabel>
								</Step>
							)
						}
					)}
				</Stepper>
				<IconButton className={props.classes.closeButton} aria-label="Close" onClick={() => {
					props.onClose(false)
				}}>
					<CloseIcon/>
				</IconButton>
			</div>
		</Dialog>
	)
}

StepDialog.propTypes = {
	classes: PropTypes.object,
	onClose: PropTypes.func.isRequired,
	open: PropTypes.bool.isRequired,
	status: PropTypes.array.isRequired,
	NinushiName: PropTypes.string,
	DenpyoNO: PropTypes.string,
	NohinYoteiYMD: PropTypes.string
};

StepDialog.defaultProps = {
	open: false,
	status: [
		'',
		'',
		'',
		''
	],
	NinushiName: '',
	DenpyoNO: '',
	NohinYoteiYMD: ''
};
export default withStyles(styles)(StepDialog);



// WEBPACK FOOTER //
// ./src/routes/delivery-status-detail/components/step-dialog.js